// extracted by mini-css-extract-plugin
export default {"mediaImage":"MediaItem_mediaImage__yC-9K","videoIconContainer":"MediaItem_videoIconContainer__2ZQsy"};